export const SCENARIO_CATEGORIES = [
  "WORLD",
  "UK",
  "US",
  "EU27",
  "JAPAN",
  "BRAZIL",
  "CHINA",
  "INDIA",
] as const;

export const SCENARIO_METRICS = ["GDP", "Inflation", "EmissionIntensity"] as const;

export type ScenarioCategory = (typeof SCENARIO_CATEGORIES)[number];
export type ScenarioMetric = (typeof SCENARIO_METRICS)[number];

export const SCENARIO_METRIC_DISPLAY_NAMES: Record<ScenarioMetric, string> = {
  GDP: "GDP",
  Inflation: "Inflation",
  EmissionIntensity: "Emission Intensity",
};

export function formatScenarioMetric(metric: string) {
  return (
    SCENARIO_METRIC_DISPLAY_NAMES[metric as ScenarioMetric] ||
    metric.replace(/([a-z])([A-Z])/g, "$1 $2")
  );
}

export const SCENARIO_COLORS = {
  baseline: "#94A3B8", // slate-400
  roaring_20s: "#60A5FA", // blue-300
  green_phoenix: "#00D492", // emeral-400
  boom_and_bust: "#615FFF", // indigo-500
  meltdown: "#FBBF24", // yellow-400
  equal_weighted: "#FF637E", // rose-400
  directional_trend: "#FF637E", // rose-400 (same as equal_weighted)
} as const;

export const SCENARIO_DISPLAY_NAMES = {
  baseline: "Baseline",
  roaring_20s: "Roaring 20s",
  green_phoenix: "Green Phoenix",
  boom_and_bust: "Boom & Bust",
  meltdown: "Meltdown",
  equal_weighted: "Equal Weighted",
  directional_trend: "Directional Trend",
} as const;

export const SCENARIO_ASSETS = [
  "baseline",
  "roaring_20s",
  "green_phoenix",
  "boom_and_bust",
  "meltdown",
  "equal_weighted",
  "directional_trend",
] as const;


export const SCENARIO_ORDER = [
  "boom_and_bust",
  "roaring_20s",
  "meltdown",
  "green_phoenix"
] as const;
